// ファイル操作関連のハンドラー
import { generateBatchCode, generateRevertBatchCode } from '../components/code-generator.js';
import { createBatchFileBlob } from '../utils/encoding.js';
import { getImportedApps } from '../state/app-state.js';
import { getSettings } from '../state/app-state.js';
import { t } from '../utils/i18n.js';
import { getCurrentPC, saveCurrentPCFromMainView } from './table-handlers.js';

/**
 * コピー機能
 */
export function copyToClipboard(): void {
    const currentSettings = getSettings();
    if (!currentSettings) return;
    const code = generateBatchCode(getImportedApps(), currentSettings);
    navigator.clipboard.writeText(code).then(() => {
        const btn = document.getElementById('copyButton');
        if (!btn) return;
        const originalText = btn.textContent;
        btn.textContent = t('copySuccess');
        btn.classList.add('bg-green-600');
        setTimeout(() => {
            if (btn) {
                btn.textContent = originalText;
                btn.classList.remove('bg-green-600');
            }
        }, 2000);
    }).catch(() => {
        alert(t('copyError') || 'Copy failed');
    });
}

/**
 * ダウンロード機能
 */
export function downloadBatchFile(): void {
    const currentSettings = getSettings();
    if (!currentSettings) return;
    
    // 選択中のPCの設定を保存
    saveCurrentPCFromMainView();
    
    const code = generateBatchCode(getImportedApps(), currentSettings);
    const blob = createBatchFileBlob(code);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    
    // ファイル名を決定（選択中のPCがある場合はPC名を使用）
    const currentPC = getCurrentPC();
    let fileName = 'setup.bat';
    if (currentPC && currentPC.pcName) {
        fileName = `setup_${sanitizeFileName(currentPC.pcName)}.bat`;
    }
    
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

/**
 * ファイル名をサニタイズ（Windowsで使えない文字を置換）
 */
function sanitizeFileName(name: string): string {
    return name
        .replace(/[<>:"/\\|?*]/g, '_')
        .replace(/\s+/g, '_')
        .substring(0, 50); // 長すぎる場合は切り詰め
}

/**
 * 元に戻すバッチファイルのダウンロード機能
 */
export function downloadRevertBatchFile(): void {
    const currentSettings = getSettings();
    if (!currentSettings) return;
    const code = generateRevertBatchCode(getImportedApps(), currentSettings);
    const blob = createBatchFileBlob(code);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'revert.bat';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

